import { useCallback, useEffect, useState } from "react";
import { PlusLg } from "react-bootstrap-icons";
import { usePlaidLink } from "react-plaid-link";
import { useFetch } from "../../features/Fetch/Fetch";
import { useItems } from "../../features/Fetch/Items";


const Link = () => {
	let [token, setToken] = useState(null);

	const request = useFetch();
	const items = useItems();

	useEffect(() => {
		let cancelled = false;
		request
			.getRaw("Settings/CreateLinkToken/false/0")
			.then((response) => response.text())
			.then((data: any) => {
				if (cancelled) return;
				setToken(data);
			});
		return () => {
			cancelled = true;
		};
	}, []);

	const onSuccess = useCallback(
		async (publicToken: any, metadata: any) => {
			await request.postRaw("Settings/ExchangePublicToken", {
				public_token: publicToken,
				metadata,
			});
			await items.GetAccountsAsync();
		},
		[items, request],
	);

	const isOauth = false;

	const config: any = {
		token,
		onSuccess,
	};

	const { open, ready } = usePlaidLink(config);

	useEffect(() => {
		if (!isOauth) return;
		if (!ready) return;
		open();
	}, [isOauth, open, ready]);

	return (
		<div className="col-12">
			<div className="btn btn-account btn-list text-app" onClick={() => open()}>
				<h3>
					<PlusLg /> Link New Financial Institution
				</h3>
			</div>
		</div>
	);
}

export default Link;